export enum EAxis {
  X = 'x',
  Y = 'y',
  Z = 'z',
}
